import React from 'react';
import * as general from '../libs/general';

// Canonical pagination component (also re-exported as `Pagination` from
// components/ui) — Giai đoạn 3 of the UI/UX upgrade plan migrates the
// duplicated inline `renderPagination()` in admin/accounting/*List.jsx to
// this component instead of keeping 3 parallel implementations.
const Paging = ({
  onPageChange,
  onItemsPerPageChange,
  pageData,
  isShowTotal = false,
  showContactFeeTotal = false,
  showCheckingFeeTotal = false,
  checkingFeeTotalLabel = 'Tổng tiền KH',
  totalLabel = 'Tổng',
  hidePaginationWhenSinglePage = false,
  showItemsPerPage = true,
  tthTotals = null,
}) => {
  var thePage = pageData;
  if (pageData.page) thePage = pageData.page
  var currentPage = thePage.number + 1;
  var totalPages = thePage.totalPages;
  var itemsPerPage = thePage.size;
  var from = currentPage - 2;
  if (from < 1) from = 1;
  var to = from + 4;
  if (to > totalPages) to = totalPages;
  if (to == totalPages) {
    from = to - 4;
    if (from < 1) from = 1;
  }
  const pageNumbers = [];

  for (let i = from; i <= to; i++) {
    pageNumbers.push(i);
  }

  const totalPackageUnitValue = Number(pageData.totalPackageUnitValue ?? 0);
  const totalPackageUnitValueText = Number.isFinite(totalPackageUnitValue)
    ? totalPackageUnitValue.toFixed(2)
    : '0.00';

  const totalPackageUnitM3 = Number(pageData.totalPackageUnitM3 ?? 0);
  const totalPackageUnitM3Text = Number.isFinite(totalPackageUnitM3)
    ? totalPackageUnitM3.toFixed(2)
    : '0.00';

  const totalContactFee = Number(pageData.totalContactFee ?? 0);
  const totalContactFeeText = Number.isFinite(totalContactFee)
    ? general.formatNumber(totalContactFee)
    : '0';

  const totalCheckingFee = Number(pageData.totalCheckingFee ?? 0);
  const totalCheckingFeeText = Number.isFinite(totalCheckingFee)
    ? general.formatNumber(totalCheckingFee)
    : '0';

  const totalTthQuantity = Number(tthTotals?.quantity ?? 0);
  const totalTthAmountCustomer = Number(tthTotals?.amountCustomer ?? 0);
  const totalTthAmountPartner = Number(tthTotals?.amountPartner ?? 0);
  const totalTthQuantityText = Number.isFinite(totalTthQuantity)
    ? general.formatDecimal(totalTthQuantity)
    : '';
  const totalTthAmountCustomerText = Number.isFinite(totalTthAmountCustomer)
    ? general.formatNumber(totalTthAmountCustomer)
    : '0';
  const totalTthAmountPartnerText = Number.isFinite(totalTthAmountPartner)
    ? general.formatNumber(totalTthAmountPartner)
    : '0';
  
  return (
    <div className="paging-wap">
      {isShowTotal && totalPackageUnitValue > 0 && <div className='d-flex align-items-center pe-5'>
        Tổng cân: {totalPackageUnitValueText} {'(kg)'}
      </div>}
      {isShowTotal && totalPackageUnitM3 > 0 && <div className='d-flex align-items-center pe-5'>
        Tổng m3: {totalPackageUnitM3Text} {'(m3)'}
      </div>}
      {isShowTotal && showContactFeeTotal && totalContactFee > 0 && <div className='d-flex align-items-center pe-5'>
        Tổng tiền ĐT: {totalContactFeeText} {'(VNĐ)'}
      </div>}
      {isShowTotal && showCheckingFeeTotal && totalCheckingFee > 0 && <div className='d-flex align-items-center pe-5'>
        {checkingFeeTotalLabel}: {totalCheckingFeeText} {'(VNĐ)'}
      </div>}
      {tthTotals && totalTthQuantity > 0 && <div className='d-flex align-items-center pe-5'>
        Tổng Tệ: {totalTthQuantityText}
      </div>}
      {tthTotals && totalTthAmountCustomer > 0 && <div className='d-flex align-items-center pe-5'>
        Tổng VNĐ KH: {totalTthAmountCustomerText} {'(VNĐ)'}
      </div>}
      {tthTotals && totalTthAmountPartner > 0 && <div className='d-flex align-items-center pe-5'>
        Tổng VNĐ ĐT: {totalTthAmountPartnerText} {'(VNĐ)'}
      </div>}
      <span className="d-flex align-items-center">{totalLabel}: {general.formatNumber(thePage.totalElements)}</span>
      {!(hidePaginationWhenSinglePage && totalPages <= 1) && (
      <div className="paging-list">
        <nav className="mx-2">
          <ul className="pagination mb-0">
            {(currentPage == 1 && totalPages > 0) && (
              <li className="page-item disabled"><button className="page-link">«</button></li>
            )}
            {(currentPage > 1) && (
              <li className="page-item "><button className="page-link" onClick={() => onPageChange(1)}>«</button></li>
            )}
            {pageNumbers.map((number) => (
              number !== currentPage ? (
                <li className="page-item" key={number}>
                  <button className="page-link" onClick={() => onPageChange(number)}>{number}</button>
                </li>
              ) : (
                <li className="page-item active" key={number}><button className="page-link">{number}</button></li>
              )
            ))}
            {(currentPage < totalPages) && (
              <li className="page-item "><button className="page-link" onClick={() => onPageChange(totalPages)}>»</button></li>
            )}
            {(currentPage == totalPages) && (
              <li className="page-item disabled"><button className="page-link">»</button></li>
            )}
          </ul>
        </nav>
        {showItemsPerPage && totalPages > 0 && (
          <div className="input-group">
            <select
              className="form-select"
              value={itemsPerPage}
              onChange={onItemsPerPageChange}
            >
              <option value={10}>10</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
            </select>
          </div>
        )}
      </div>
      )}
    </div>
  );
};

export default Paging;
